// import Vue from "vue";
// import { checkResponse } from "@/helpers/store";

const state = {};

const mutations = {};

const actions = {};

const getters = {};

export default { state, mutations, actions, getters };
